// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0cdf939d","952":"e147b5f9"}[chunkId] + ".chunk.js";
};